module.exports = __webpack_public_path__ + "img/image45.f8044050.png";